export default "<button hex-button\n        hexType=\"secondary\"\n        [disabled]=\"ctaDisabled\">\n  {{buttonLabel}}\n</button>"